<template>
  <div class="bg-beige">
    <loading-component class="mt-5" v-if="loading" />
    <div v-else>
      <error-component v-if="errored" :error-message="getErrorMessage"/>
      <div v-else class="mx-2">

        <div v-b-visible="handleVisible" class="d-block d-lg-none" style="position: fixed; z-index: -10; height: 1px; width: 1px; background-color: #F3F0EB"></div>

        <h5 class="mt-3 text-center">Jahresauswahl</h5>
        <b-pagination v-model="currentPageYears" :total-rows="years.length" :per-page="1" :align="isBreakPointLg === true ? 'center' : 'fill'" style="margin-bottom: 0px;" first-number last-number>
          <template #page="{ page }">
            <span v-if="page < years.length">{{ page + years[0] - 1}}</span>
            <span v-else>{{ years[page-1]}}</span>
          </template>
        </b-pagination>

        <h3 class="mt-4">Visualisierung Quartalwerte
          <svg v-b-tooltip.hover.bottom title="Die nachfolgenden Diagramme zeigen die generierten Umsätze je Quartal. Hierbei werden nur abgeschlossene Aufträge betrachtet." width="20" height="20" fill="currentColor" class="bi bi-question-circle" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
          </svg>
        </h3>
        <b-card
            class="mb-2 bg-beige"
        >
          <div class="row">
            <loading-component v-if="barChartData === null"/>
            <BarChartComponent v-else :chart-data="barChartData" class="col-lg-8 col-md-12" />
            <loading-component v-if="pieChartData === null"/>
            <PieChartComponent :chart-data="pieChartData" class="col-lg-4 col-md-12" />
          </div>
        </b-card>

        <!--
        <h5 class="mt-3 text-center">Jahresauswahl</h5>
        <div class="d-flex justify-content-center align-items-center flex-wrap">
          <div class="p-2">
            <b-pagination v-model="currentPageYears" :total-rows="years.length" :per-page="1" :align="isBreakPointLg === true ? 'center' : 'fill'" style="margin-bottom: 0px;" first-number last-number>
              <template #page="{ page }">
                <span v-if="page < years.length">{{ page + years[0] - 1}}</span>
                <span v-else>{{ years[page-1]}}</span>
              </template>
            </b-pagination>
          </div>
          <div class="p-2"><b-button variant="primary" @click="selectAllYears()">Alle Jahre</b-button></div>
        </div>
        -->

        <h3 class="mt-3">Übersicht aller Deals des Jahres
          <svg v-b-tooltip.hover title="Hier werden alle Deals des oben gewählten Jahres angezeigt. Aufgeschlüsselt wird nach gewähltem Monat oder über das gesamte Jahr." width="20" height="20" fill="currentColor" class="bi bi-question-circle" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
          </svg>
        </h3>
        <b-card no-body>
          <b-tabs card fill>
            <b-tab title="Gesamt" active>
              <b-card-text>
                <div v-if="currentPageYears !== years.length">
                <h5 class="mt-3 text-center">Monatsauswahl</h5>
                <b-pagination class="mb-5" :limit=13 v-model="currentPageMonths" :total-rows="months.length" :per-page="1" :align="isBreakPointLg === true ? 'center' : 'fill'" style="margin-bottom: 0px;" first-number last-number>
                  <template #page="{ page }">
                    <span v-if="page < months.length">{{ page + months[0] - 1}}</span>
                    <span v-else>{{ months[page-1]}}</span>
                  </template>
                </b-pagination>
                </div>

                <CategoryComponent :deals="filteredData" :key="componentKey" :pipeline="'alle'"/>
              </b-card-text>
            </b-tab>
            <b-tab title="Inbound">
              <b-card-text>
                <h5 class="mt-3 text-center">Monatsauswahl</h5>
                <b-pagination class="mb-5" :limit=13 v-model="currentPageMonths" :total-rows="months.length" :per-page="1" :align="isBreakPointLg === true ? 'center' : 'fill'" style="margin-bottom: 0px;" first-number last-number>
                  <template #page="{ page }">
                    <span v-if="page < months.length">{{ page + months[0] - 1}}</span>
                    <span v-else>{{ months[page-1]}}</span>
                  </template>
                </b-pagination>

                <CategoryComponent :deals="getInboundDeals" :key="componentKey" :pipeline="'inbound'"/>
              </b-card-text>
            </b-tab>
            <b-tab title="Outbound">
              <b-card-text>
                <h5 class="mt-3 text-center">Monatsauswahl</h5>
                <b-pagination class="mb-5" :limit=13 v-model="currentPageMonths" :total-rows="months.length" :per-page="1" :align="isBreakPointLg === true ? 'center' : 'fill'" style="margin-bottom: 0px;" first-number last-number>
                  <template #page="{ page }">
                    <span v-if="page < months.length">{{ page + months[0] - 1}}</span>
                    <span v-else>{{ months[page-1]}}</span>
                  </template>
                </b-pagination>

                <CategoryComponent :deals="getOutboundDeals" :key="componentKey" :pipeline="'outbound'"/>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>

        <br>

      </div>
    </div>
  </div>
</template>

<script>
import { getAllDeals } from '../client/index'
import BarChartComponent from '@/components/BarChartComponent'
import PieChartComponent from '@/components/PieChartComponent'
import CategoryComponent from '@/components/CategoryComponent'
import ErrorComponent from '@/components/ErrorComponent'
import LoadingComponent from '@/components/LoadingComponent'
import moment from 'moment'
export default {
  name: 'Dashboard-View',
  components: { LoadingComponent, ErrorComponent, CategoryComponent, BarChartComponent, PieChartComponent },
  props: ['dealId'],
  data () {
    return {
      userToken: '',
      password: '',
      loading: true,
      error: null,
      errored: false,
      data: null,
      filteredData: null,
      years: null,
      months: null,
      errorMessage: 'Beim Laden der Deals trat ein Fehler auf.',
      barChartData: null,
      pieChartData: null,
      currentPageYears: null,
      currentPageMonths: null,
      isBreakPointLg: null,
      componentKey: 0
    }
  },
  beforeMount () {
    getAllDeals(this.dealId, (data, error) => {
      this.loading = false
      if (error) {
        this.errored = true
        this.error = error
        console.log('comp errored!')
      }
      if (data) {
        this.data = data.deals
        this.filteredData = data.deals
        data.years.push('Alle')
        this.years = data.years
        this.currentPageYears = this.years.length - 1
        this.months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 'Alle']
        this.currentPageMonths = moment().month() + 1
        this.barChartData = this.getBarChartData(
          this.getFullYearNumbers(this.getInboundDealsRechnung),
          this.getFullYearNumbers(this.getOutboundDealsRechnung),
          this.getFullYearNumbers(this.filteredData.filter((deal) => deal.Kategorie === '3')), this.years[this.years.length - 1]
        )
        this.pieChartData = this.getPieChartData(
          this.getSumOfBetrag(this.getInboundDealsRechnung),
          this.getSumOfBetrag(this.getOutboundDealsRechnung)
        )
      }
    })
  },
  computed: {
    getInboundDeals () {
      if (this.currentPageMonths !== 13) {
        return this.filteredData.filter((deal) => (deal.Pipeline === 'Inbound' && moment(deal.Erstellungsdatum).month() + 1 === this.months[this.currentPageMonths - 1]))
      } else {
        return this.filteredData.filter((deal) => (deal.Pipeline === 'Inbound'))
      }
    },
    getOutboundDeals () {
      if (this.currentPageMonths !== 13) {
        return this.filteredData.filter((deal) => (deal.Pipeline === 'Outbound' && moment(deal.Erstellungsdatum).month() + 1 === this.months[this.currentPageMonths - 1]))
      } else {
        return this.filteredData.filter((deal) => (deal.Pipeline === 'Outbound'))
      }
    },
    getInboundDealsRechnung () {
      return this.filteredData.filter((deal) => (deal.Pipeline === 'Inbound' && deal.Kategorie === '3'))
    },
    getOutboundDealsRechnung () {
      return this.filteredData.filter((deal) => (deal.Pipeline === 'Outbound' && deal.Kategorie === '3'))
    },
    getErrorMessage () {
      return this.errorMessage + ' - ID: ' + this.$route.params.id + ' | ' + this.error
    }
  },
  methods: {
    getFullYearNumbers (deals) {
      const quartals = [['01', '02', '03'], ['04', '05', '06'], ['07', '08', '09'], ['10', '11', '12']]

      return quartals.map((quartal) => {
        const quartalDeals = this.getQuartalDeals(quartal, deals)
        return this.getSumOfBetrag(quartalDeals)
      })
    },
    getQuartalDeals (quartal, deals) {
      return deals.filter((deal) => {
        const date = deal.Erstellungsdatum.split(' ')[0]
        const month = date.split('-')[1]
        return month === quartal[0] || month === quartal[1] || month === quartal[2]
      })
    },
    getSumOfBetrag (deals) {
      const array = deals.map((deal) => {
        if (deal.Betrag !== null && deal.Betrag !== '') {
          return deal.Betrag
        }
        return deal.Betrag
      })

      return array.reduce((accumulator, value) => {
        return accumulator + +value
      }, 0)
    },
    getBarChartData (dataInbound, dataOutbound, data, year) {
      return {
        labels: [
          'Q1/' + year,
          'Q2/' + year,
          'Q3/' + year,
          'Q4/' + year
        ],
        datasets: [
          {
            label: 'Inbound',
            backgroundColor: '#90e0ef',
            data: dataInbound
          }, {
            label: 'Outbound',
            backgroundColor: '#0096c7',
            data: dataOutbound
          }, {
            label: 'Gesamt',
            backgroundColor: '#f87979',
            data: data
          }
        ]
      }
    },
    getPieChartData (dataInbound, dataOutbound) {
      return {
        labels: ['Inbound', 'Outbound'],
        datasets: [
          {
            backgroundColor: ['#90e0ef', '#0096c7'],
            data: [dataInbound, dataOutbound]
          }
        ]
      }
    },
    refreshDashboardCharts (year) {
      if (year === 0) {
        this.filteredData = this.data
        // this.currentPageMonths = 13
        year = 'Gesamt'
      } else {
        this.filteredData = this.data.filter((deal) => moment(deal.Erstellungsdatum).year() === year)
      }
      this.barChartData = this.getBarChartData(
        this.getFullYearNumbers(this.getInboundDealsRechnung),
        this.getFullYearNumbers(this.getOutboundDealsRechnung),
        this.getFullYearNumbers(this.filteredData.filter((deal) => deal.Kategorie === '3')), year
      )
      this.pieChartData = this.getPieChartData(
        this.getSumOfBetrag(this.getInboundDealsRechnung),
        this.getSumOfBetrag(this.getOutboundDealsRechnung)
      )
      if (year !== 'Gesamt') {
        this.filteredData = this.data.filter((deal) => (moment(deal.Erstellungsdatum).year() === year && moment(deal.Erstellungsdatum).month() + 1 === this.months[this.currentPageMonths - 1]))
      }
    },
    selectAllYears () {
      this.refreshDashboardCharts(0)
    },
    refreshDashboardDeals (month) {
      if (month === 0) {
        this.filteredData = this.data.filter((deal) => moment(deal.Erstellungsdatum).year() === this.years[this.currentPageYears - 1])
        console.log(this.filteredData)
        month = 'Gesamt'
      } else {
        this.filteredData = this.data.filter((deal) => (moment(deal.Erstellungsdatum).year() === this.years[this.currentPageYears - 1] && moment(deal.Erstellungsdatum).month() + 1 === month))
        // console.log('month:', month, moment(this.filteredData[0].Erstellungsdatum).month() + 1, this.months[this.currentPageMonths - 1])
      }
    },
    selectAllMonths () {
      this.refreshDashboardDeals(0)
    },
    handleVisible (isVisible) {
      this.isBreakPointLg = !isVisible
      // console.log(this.isBreakPointLg)
    },
    forceRerender () {
      this.componentKey += 1
    }
  },
  watch: {
    currentPageYears: function (pageVal) {
      // console.log('Change to page', pageVal)
      if (pageVal !== null && pageVal !== this.years.length) {
        this.refreshDashboardCharts(pageVal + this.years[0] - 1)
      }
      if (pageVal !== null && pageVal === this.years.length) {
        this.selectAllYears()
      }
      if (pageVal !== null && this.currentPageMonths === 13 && pageVal !== this.years.length) {
        this.refreshDashboardDeals(0)
      }
      this.forceRerender()
    },
    currentPageMonths: function (pageVal) {
      // console.log('Change to page', this.months[this.currentPageMonths - 1], pageVal + this.months[0] - 1)
      if (pageVal !== null && pageVal !== this.months.length) {
        this.refreshDashboardDeals(pageVal + this.months[0] - 1)
      }
      if (pageVal !== null && pageVal === this.months.length) {
        this.selectAllMonths()
      }
      this.forceRerender()
    }
  }
}
</script>

<style>
.bg-beige {
  background-color: #F3F0EB !important;
}

.page-link {
  background-color: #2e2e2e !important;
  border-color: #464646 !important;
  color: #FFF !important;
}

.page-link:hover {
  background-color: #353535 !important;
}

.pagination > li.active > button {
  background: #EC5500 !important;
  color: #FFF !important;
  border-color: #EC5500 !important;
}
</style>
